import Q from 'q';

import API from 'js/lib/api';
import stringKeyTuple from 'js/lib/stringKeyTuple';

const api = API('', { type: 'rest' });

const resource = '/api/onDemandCourseGradeItemOutcomeOverrides.v1/';

type OptionsIds = {
  learnerId: number;
  courseId: string;
  itemId: string;
};

type OverrideOptions = OptionsIds & {
  grade: number;
  isPassed?: boolean;
  explanation: string;
};

export default {
  getOverride(options: OptionsIds) {
    const key = stringKeyTuple.tupleToStringKey([options.learnerId.toString(), options.courseId, options.itemId]);
    const fields = '?fields=grade,isPassed,explanation,userPublicProfiles.v1(fullName)&includes=publicProfiles';
    const path = resource + key + fields;
    return Q(api.get(path));
  },

  updateOverride(options: OverrideOptions) {
    const key = stringKeyTuple.tupleToStringKey([options.learnerId.toString(), options.courseId, options.itemId]);
    const path = resource + key;
    return Q(
      api.put(path, {
        data: {
          grade: options.grade,
          isPassed: options.isPassed,
          explanation: options.explanation,
        },
      })
    );
  },

  removeOverride(options: OptionsIds) {
    const key = stringKeyTuple.tupleToStringKey([options.learnerId.toString(), options.courseId, options.itemId]);
    const path = resource + key;
    return Q(api.delete(path));
  },
};
